import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/net-worth-percentile',
  component: () => import('../../routes/NetWorthPercentile.svelte'),
  card: {
    id: 'net-worth-percentile',
    title: 'Net Worth Percentile',
    description: 'Find your net worth percentile by age. Compare your wealth against U.S. household benchmarks based on Federal Reserve data.',
    icon: 'leaderboard',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/net-worth-percentile',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Net Worth Percentile Calculator – Compare Your Wealth by Age',
    description:
      'Free net worth percentile calculator. Enter your age and net worth to see how you compare to U.S. households. Uses Federal Reserve SCF wealth distribution data for accurate age-based benchmarks.',
  },
};

export default meta;
